import { Card, Col, Row, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { BookOutlined, VideoCameraOutlined } from "@ant-design/icons";
import { Tv } from "lucide-react";

const { Title, Text } = Typography;

const COLORS = {
  books: "#52c41a",
  movies: "#1677ff",
  series: "#faad14",
};

export function MyLibraryAddPage() {
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: 800, margin: "0 auto" }}>
      <Title level={2} style={{ marginTop: 0, marginBottom: 24 }}>
        Dodaj do mojej biblioteki
      </Title>

      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Card
            hoverable
            onClick={() => navigate("/my-library/add/book")}
            style={{ borderLeft: `4px solid ${COLORS.books}` }}
          >
            <Title level={4} style={{ marginTop: 0, color: COLORS.books }}>
              <BookOutlined /> Książka
            </Title>
            <Text type="secondary">
              Dodaj ukończoną książkę (data ukończenia, ocena, notatka).
            </Text>
          </Card>
        </Col>

        <Col xs={24}>
          <Card
            hoverable
            onClick={() => navigate("/my-library/add/movie")}
            style={{ borderLeft: `4px solid ${COLORS.movies}` }}
          >
            <Title level={4} style={{ marginTop: 0, color: COLORS.movies }}>
              <VideoCameraOutlined /> Film
            </Title>
            <Text type="secondary">
              Dodaj film + dane seansu: kino, sala, data/godzina.
            </Text>
          </Card>
        </Col>

        <Col xs={24}>
          <Card
            hoverable
            onClick={() => navigate("/my-library/add/series")}
            style={{ borderLeft: `4px solid ${COLORS.series}` }}
          >
            <Title level={4} style={{ marginTop: 0, color: COLORS.series }}>
              <Tv size="1em" style={{ marginRight: 4, transform: "translateY(2px)" }} /> Serial (sezon)
            </Title>
            <Text type="secondary">
              Dodaj ukończony sezon serialu (wybór sezonu).
            </Text>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default MyLibraryAddPage;

